import { Col, Row } from 'react-bootstrap';
import ColumnsChart from '../../../../components/ApexCharts/ColumnsChart';
import ColumnsCustomLegend from '../../../../components/ApexCharts/CustomLegends/ColumnsCustomLegend';
import Blockquote from '../../../../components/Blockquote';
import { formatPrice } from '../../../../utils/utils';

const healthChartData = {
  chart: {
    stacked: true,
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  colors: [
    '#C4D2D9',
    '#4381A5',
    '#2A556D',
    '#F83966',
    '#F48462',
    '#F17AD0',
    '#0C9C8E',
  ],
  series: [
    {
      name: 'Medical',
      data: [7000, 3500],
    },
    {
      name: 'Nicotine-Free Discount',
      data: [0, -200],
    },
    {
      name: 'Dental',
      data: [3000, 200],
    },
    {
      name: 'Vision',
      data: [3650, 250],
    },
    {
      name: 'Health Care Flexible Spending Acount',
      data: [0, 1500],
    },
    {
      name: 'Basic Employee Life and AD&D',
      data: [2255, 0],
    },
    {
      name: 'Supplemental Employee Life and AD&D',
      data: [0, 4400],
    },
  ],

  dataLabels: {
    enabled: false,
  },
  fill: {
    opacity: 1,
  },
  legend: {
    show: false,
  },
  plotOptions: {
    bar: {
      horizontal: false,
    },
  },
  tooltip: {
    enabled: false,
  },
  xaxis: {
    categories: [1, 2, 3, 4, 5, 6, 7, 8],
    overwriteCategories: ['We Contribute', 'You Contribute'],
  },
  yaxis: {
    title: {
      text: '',
    },
    min: -2500,
    max: 17500,
    tickAmount: 8,

    labels: {
      formatter: function (a: any) {
        return formatPrice(a, 'en-US', {
          currency: 'USD',
          style: 'currency',
          minimumFractionDigits: 0,
        });
      },
    },
  },
};

const HealthAndWelfareTab = () => {
  return (
    <div className="pt-11">
      <Row>
        <h5>Health and Welfare</h5>
      </Row>
      <Row>
        <span className="text-light-grey text-fs-6 fw-light">
          Review your company's contributions versus your contributions below.
        </span>
      </Row>
      <Row className="pt-11 lh-xs px-4">
        <Blockquote>
          <section>
            <Row>
              <Col className="title-span fw-bolder">
                Let's help you understand this information
              </Col>
            </Row>
            <Row>
              <Col>
                There is a cost sharing aspect to the benefits you get from the
                company. This table shows what the company pays and what you
                pay. These are, for the most part, pre-tax dollars.
              </Col>
            </Row>
          </section>
        </Blockquote>
      </Row>
      <Row className="pt-12 px-lg-0">
        <Col className="col-12 ">
          <ColumnsChart
            series={healthChartData.series}
            options={healthChartData}
          />
        </Col>
      </Row>
      <Row className="pt-12 px-lg-0 px-5">
        <Col className="pt-3 lh-xs col-12 px-lg-7 ">
          <Row className="text-fs-6 fw-light pt-3 pb-3 lh-xs border-bottom">
            <Col className="col-6 text-ligther-grey fw-normal">Compensation</Col>
            <Col className="col-3 text-end fw-normal">We contribute</Col>
            <Col className="col-3 text-end fw-normal">You contribute</Col>
          </Row>
          <ColumnsCustomLegend
            series={healthChartData.series}
            colors={healthChartData.colors}
            total={['$15,905', '$9,650']}
          />
        </Col>
      </Row>
      <Row className="pt-12 px-7 text-light-grey text-fs-6 fw-light">
        You currently have credits that offset your total cost.
      </Row>
      <Row className="pt-11 mt-11 lh-xs">
        <h5>Suggestions</h5>
      </Row>
      <Row className="pt-7 lh-xs px-lg-0 px-7">
        <Blockquote>
          <section>
            <Row>
              <Col className="title-span fw-bolder">Visual Benefits</Col>
            </Row>
            <Row>
              <Col>
                Make sure you use your vision benefits before the end of the
                year. You are paying $250/year.
              </Col>
            </Row>
          </section>
        </Blockquote>
      </Row>
      <Row className="pt-7 lh-xs px-lg-0 px-7">
        <Blockquote>
          <section>
            <Row>
              <Col className="title-span fw-bolder">Dental Benefits</Col>
            </Row>
            <Row>
              <Col>
                Don't forget about your dental coverage! Most dental plans cover
                teeth cleanings twice per year, as well as some orthodontic
                coverage.
              </Col>
            </Row>
          </section>
        </Blockquote>
      </Row>
      <Row className="pt-7 lh-xs px-lg-0 px-7">
        <Blockquote>
          <section>
            <Row>
              <Col className="title-span fw-bolder">Day Care</Col>
            </Row>
            <Row>
              <Col>
                If you contribute to a Day Care Flexible Account, you can save
                on child care costs by paying for them with pre-tax dollars.
                Consider this during the next enrollment period.
              </Col>
            </Row>
          </section>
        </Blockquote>
      </Row>
    </div>
  );
};

export default HealthAndWelfareTab;
